import { useTranslation } from "react-i18next";
import type { TCitationObject } from "../../../../../services/api/instances/researchApi/types";
import { AppAccordion } from "../../../../../shared/components/AppAcordion";
import styles from "./styles.module.css";

interface Props {
  citation: TCitationObject;
  indexNumber: number;
  className?: string;
}

export const CitationCard = ({ citation, indexNumber, className }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles["citation-container"]}>
      <h4
        className={styles["citation-title"]}
      >{`${indexNumber + 1}. ${citation.title}`}</h4>
      <a
        href={citation.url}
        className={styles["citation-link"]}
        target={"_blank"} rel="noreferrer"
      >
        {citation.url}
      </a>
      {citation.excerpts.length > 0 && (
        <AppAccordion title={t("research.excerpts")}>
          {citation.excerpts.map((excerpt, index) => (
            <div key={index} className={styles["citation-excerpt"]}>
              {`${index + 1}. ${excerpt}`}
            </div>
          ))}
        </AppAccordion>
      )}
    </div>
  );
};
